module.exports = __webpack_public_path__ + "img/03_Button-2.639fb31a.png";